var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analise" },
    [
      _c("h3", { staticClass: "titulo-cadastar-foto" }, [
        _vm._v("Status no Flowable")
      ]),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-label", {
                    attrs: { label: "Digite o N° do Processo:" }
                  }),
                  _c(
                    "el-input",
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "#########/####",
                          expression: "'#########/####'"
                        }
                      ],
                      attrs: {
                        placeholder: "Digite o número do processo",
                        size: "small",
                        clearable: "clearable"
                      },
                      model: {
                        value: _vm.numProcesso,
                        callback: function($$v) {
                          _vm.numProcesso = $$v
                        },
                        expression: "numProcesso"
                      }
                    },
                    [
                      _c("el-button", {
                        staticClass: "color-default",
                        attrs: {
                          slot: "append",
                          icon: "el-icon-search",
                          id: "botao-pesquisar"
                        },
                        on: { click: _vm.pesquisar },
                        slot: "append"
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: this.processo.perfil != "",
                          expression: "this.processo.perfil != ''"
                        }
                      ],
                      staticClass: "container-botao"
                    },
                    [
                      _c("h3", [
                        _vm._v("Processo " + _vm._s(" " + this.numProcesso))
                      ]),
                      _c(
                        "el-button",
                        {
                          staticClass: "botao-sinc",
                          class: {
                            botaoAdd: _vm.verificaStatusProcesso()
                              ? false
                              : true
                          },
                          attrs: {
                            type: "secundary",
                            id: "botao-add",
                            disabled:
                              _vm.verificaStatusProcesso() === true
                                ? true
                                : false
                          },
                          on: { click: _vm.sincronizar }
                        },
                        [
                          _c("span", {
                            class:
                              _vm.verificaStatusProcesso() === true
                                ? "repeat-icon-disabled"
                                : "repeat-icon"
                          }),
                          _vm._v("Sincronizar status")
                        ]
                      )
                    ],
                    1
                  ),
                  (_vm.verificaStatusProcesso() === true
                  ? true
                  : false)
                    ? _c("span", { staticClass: "info-status" }, [
                        _vm._v(
                          "Não é possível sincronizar pois o status já se encontra atualizado"
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.processo.cpfCnpjInteressado != ""
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-container",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("h3", [_vm._v("Dados do Flowable")]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Nome do interessado:")
                            ]),
                            _vm._v(
                              _vm._s(
                                " " + _vm.processo.nomeRazaoSocialInteressado
                              )
                            )
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("CPF/CNPJ:")
                            ]),
                            _vm._v(
                              _vm._s(" " + _vm.processo.cpfCnpjInteressado)
                            )
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Perfil:")
                            ]),
                            _vm._v(_vm._s(" " + _vm.processoFlowable.perfil))
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Setor:")
                            ]),
                            _vm._v(_vm._s(" " + _vm.processoFlowable.setor))
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Status:")
                            ]),
                            _vm._v(_vm._s(" " + _vm.processoFlowable.status))
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Usuário:")
                            ]),
                            _vm._v(
                              _vm._s(
                                _vm.processo.usuario
                                  ? " " + _vm.processo.usuario
                                  : " " + "Usuário não encontrado"
                              )
                            )
                          ]),
                          this.processo.status != this.processoFlowable.status
                            ? _c("div", { staticClass: "alert-container" }, [
                                _c("div", { staticClass: "alert-message" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "alert-text",
                                      staticStyle: { color: "red" }
                                    },
                                    [_vm._v("Atenção")]
                                  )
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass: "alert-description",
                                    staticStyle: { "font-weight": "bold" }
                                  },
                                  [
                                    _vm._v(
                                      "Divergência de dados detectada entre o Flowable e o banco de dados"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.processo.cpfCnpjInteressado != ""
                    ? _c(
                        "el-card",
                        {
                          staticClass: "card-container",
                          attrs: { shadow: "hover" }
                        },
                        [
                          _c("h3", [_vm._v("Banco de dados")]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Nome do interessado:")
                            ]),
                            _vm._v(
                              _vm._s(
                                " " + _vm.processo.nomeRazaoSocialInteressado
                              )
                            )
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("CPF/CNPJ:")
                            ]),
                            _vm._v(
                              _vm._s(" " + _vm.processo.cpfCnpjInteressado)
                            )
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Perfil:")
                            ]),
                            _vm._v(_vm._s(" " + _vm.processo.perfil))
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Setor:")
                            ]),
                            _vm._v(_vm._s(" " + _vm.processo.setor))
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Status:")
                            ]),
                            _vm._v(_vm._s(" " + _vm.processo.status))
                          ]),
                          _c("div", { staticClass: "info-item" }, [
                            _c("span", { staticClass: "info-label" }, [
                              _vm._v("Usuário:")
                            ]),
                            _vm._v(
                              _vm._s(
                                _vm.processo.usuario
                                  ? " " + _vm.processo.usuario
                                  : " " + "Usuário não encontrado"
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fa3e170", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fa3e170","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/VerificaStatusProcesso.vue
// module id = null
// module chunks = 